import { getIYIPortfolio } from '@/services/rest/iyi-portfolio';
import { createSlice } from '@reduxjs/toolkit';

export const iyiPortfolioSlice = createSlice({
  name: 'IYIPortfolio',
  initialState: {
    isLoading: false,
    error: null,
    myInvestment: [],
  },
  reducers: {
    setIYIPortfolioLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIYIPortfolioData: (state, action) => {
      state.isLoading = false;
      state.myInvestment = action.payload;
      state.error = null;
    },
    setIYIPortfolioError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// Thunk
export const fetchIYIPortfolioThunk = () => async (dispatch) => {
  dispatch(setIYIPortfolioLoading(true));
  try {
    const response = await getIYIPortfolio();
    dispatch(setIYIPortfolioData(response?.data));
  } catch (error) {
    dispatch(setIYIPortfolioError(error.message));
  }
};

// ACTIONS
export const { setIYIPortfolioLoading, setIYIPortfolioData, setIYIPortfolioError } =
  iyiPortfolioSlice.actions;

// REDUCERS
export default iyiPortfolioSlice.reducer;
